import styled, { css } from 'styled-components';

export const TeamWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  flex-direction:${props => (props.isAColumn ? 'column' : 'row')};
  border-radius:${props => (props.isSquad ? '50%' : '')};
  margin:${props => (props.marginWrapper ? props.marginWrapper : '0px')};
  ${props => (props.justifyContent) && css` 
    justify-content: ${props.justifyContent};
  `};
`;

export const TeamLogo = styled.img`
  height: ${props => (props.isMatchPage ? '85px' : '30px')};
  image-rendering: optimizeSpeed;
  -ms-interpolation-mode: nearest-neighbor;
  ${props => props.width && css`
    width: ${props.width};
    height: auto;
  `};
  ${props => props.height && css`
    height: ${props.height};;
  `};
  ${props => props.isPlayer && css`
    height: 34px;
    width: 34px;
  `};
  ${props => props.isForma && css`
    height: 45px;
  `};
  ${props => props.isFlag && css`
    height: 20px;
    width: 30px;
  `};
  ${props => props.isHeader && css`
    height: 50px;
  `};
  ${props => props.isStripCalendar && css`
    height: 28px;
    width: 28px;
  `};
  ${props => props.isWorldCup && css`
    height: 36px;
  `};
  ${props => props.isCorriereCalendar && css`
    border-radius: 4px;
    height: 32px;
    width: 32px;
  `};
   ${props => props.noFavStar && css`
    height: 15px;
    width: 20px;
  `};
  &.placeholder {
    max-height: 33px;
  }
`;

export const TeamName = styled.div`
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  margin-left: ${props => props.marginLeft}em;
  margin-top: ${props => props.marginTop}px;
  margin-right: ${props => props.marginRight}em;
  text-align: ${props => (props.alignment ? props.alignment : 'left')};
  font-size: 18px;
  text-transform: ${props => (props.isUpperCase ? 'uppercase' : 'initial')};
  ${props => (props.size) && css` 
    font-size: ${props.size}px;
  `};
  ${props => (props.font) && css`
    font-family: ${props.theme.fontSets[props.font]};
  `};
  width: ${props => (props.textWidth ? props.textWidth : 'auto')};
  ${props => (props.whiteSpace) && css` 
    white-space: ${props.whiteSpace};
  `};
  text-overflow: ellipsis;
  overflow: hidden;
`;



// WEBPACK FOOTER //
// ./src/components/shared/TeamLabel/styles.js